import { Capability } from '../../models/Onboarding'
import { GrowthTrackEvent } from '../../apps/professional-app/fa/common/tracking'

export const CAPABILITY_TO_GROWTH_EVENT: Partial<Record<Capability, GrowthTrackEvent>> = {
  [Capability.CALENDAR_SOURCE]: GrowthTrackEvent.ONBOARDING_CALENDAR_INTEGRATION_CLICKED,
  [Capability.CONTACT_SOURCE]: GrowthTrackEvent.ONBOARDING_CONTACT_SOURCE_INTEGRATION_CLICKED,
  [Capability.FINANCIAL_PLANNING]: GrowthTrackEvent.ONBOARDING_FINANCIAL_PLANNING_INTEGRATION_CLICKED,
  [Capability.MAIL]: GrowthTrackEvent.ONBOARDING_MAIL_INTEGRATION_CLICKED,
  [Capability.ZOOM]: GrowthTrackEvent.ONBOARDING_ZOOM_CLICKED,
}

export const deriveTrackingOriginFromReturnPath = (returnPath: string): string | undefined => {
  if (returnPath.includes('/onboarding')) {
    return 'onboarding'
  } else if (returnPath.includes('/upcoming')) {
    return 'upcoming'
  } else if (returnPath.includes('/manage-contacts')) {
    return 'contacts'
  }
  return undefined
}
